import { formTypes } from '.';
import { accountSubTypeValueLabelList, sourceAccountsValueLabelList } from '../../catalogs/banks';
import { documentTypesValueAbreviationList, documentTypesValueLabelList } from '../../catalogs/documentTypes';
import { personTypesValueLabelList } from '../personTypes';
import { regimesValueLabelList } from '../regimes';

export const supplierGeneralFields = {
  infoBank: {
    key: 'infoBank',
    label: '¿Quiere asociar cuentas bancarias al proveedor?',
    type: formTypes.checkbox,
    options: [{ key: 'yes', label: 'Sí' }],
    cols: 2
  },
  typeOfPerson: {
    key: 'typeOfPerson',
    label: 'Naturaleza jurídica',
    type: formTypes.select,
    options: personTypesValueLabelList
  },
  name: { key: 'name', label: 'Nombre', placeholder: 'Juan Andrés' },
  lastName: {
    key: 'lastName',
    label: 'Apellido',
    show: value => value.typeOfPerson !== '1' || value.typeOfPerson === undefined,
    placeholder: 'Rodríguez Pérez'
  },
  businessName: {
    key: 'businessName',
    label: 'Razón social',
    show: value => value.typeOfPerson === '1',
    placeholder: 'Republic Motors Incorporation'
  },
  identificationType: {
    key: 'identificationType',
    label: 'Tipo de identificación',
    type: formTypes.select,
    options: documentTypesValueLabelList,
    show: value => value.typeOfPerson !== '1'
  },
  identificationNumber: {
    keyType: 'identificationType',
    optionsType: documentTypesValueAbreviationList,
    key: 'identificationNumber',
    label: 'Identificación',
    type: formTypes.identification,
    popover: 'Si eres persona jurídica, el NIT debe tener 10 caracteres (CON dígito de verificación, sin guión)',
    placeholder: '9000000',
    textHelper: 'Verifica el tipo de documento antes de continuar'
  },
  email: { key: 'email', label: 'Correo general', validate: true, placeholder: 'hola@ejemplo.com' },
  regime: {
    key: 'regime',
    label: 'Régimen',
    type: formTypes.select,
    options: regimesValueLabelList,
    show: value => value.typeOfPerson === '1'
  },
  phone: {
    keyIndicative: 'phoneIndicative',
    key: 'phone',
    label: 'Teléfono o celular',
    type: formTypes.phone,
    placeholder: '300 000 000'
  }
};

export const supplierBankFields = {
  infoUser: {
    key: 'infoUser',
    label: '',
    type: formTypes.checkbox,
    options: [{ key: 'yes', label: '¿La información del titular de la cuenta coincide con la información general?' }],
    cols: 2
  },
  bankId: { key: 'druoBankId', label: 'Banco', type: formTypes.selectComplete, options: sourceAccountsValueLabelList },
  bankAccountNumber: { key: 'bankAccountNumber', label: 'Número de cuenta', type: formTypes.text, placeholder: '9000000' },
  bankAccountSubtype: {
    key: 'druoBankAccountSubtype',
    label: 'Tipo de cuenta',
    type: formTypes.select,
    options: accountSubTypeValueLabelList
  },
  typeOfPerson: {
    key: 'paymentTypeOfPerson',
    label: 'Naturaleza jurídica',
    type: formTypes.select,
    options: personTypesValueLabelList
  },
  name: { key: 'paymentName', label: 'Nombre', placeholder: 'Juan Andrés' },
  lastName: {
    key: 'paymentLastName',
    label: 'Apellido',
    show: value => value.paymentTypeOfPerson !== '1' || value.paymentTypeOfPerson === undefined,
    placeholder: 'Rodríguez Pérez'
  },
  businessName: {
    key: 'paymentBusinessName',
    label: 'Razón social',
    show: value => value.paymentTypeOfPerson === '1',
    placeholder: 'Republic Motors Incorporation'
  },
  identificationType: {
    key: 'paymentIdentificationType',
    label: 'Tipo de identificación',
    type: formTypes.select,
    options: documentTypesValueLabelList,
    show: value => value.paymentTypeOfPerson !== '1'
  },
  identificationNumber: {
    keyType: 'paymentIdentificationType',
    optionsType: documentTypesValueAbreviationList,
    key: 'paymentIdentificationNumber',
    label: 'Identificación',
    type: formTypes.identification,
    popover: 'Si eres persona jurídica, el NIT debe tener 10 caracteres (CON dígito de verificación, sin guión)',
    placeholder: '9000000',
    textHelper: 'Verifica el tipo de documento antes de continuar'
  },
  email: { key: 'paymentEmail', label: 'Correo general de empresa', validate: true, placeholder: 'hola@ejemplo.com' }
};
